import { render, staticRenderFns } from "./PulloutQuestionMultiSwitch.vue?vue&type=template&id=a9940a8c&scoped=true&"
import script from "./PulloutQuestionMultiSwitch.vue?vue&type=script&lang=js&"
export * from "./PulloutQuestionMultiSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PulloutQuestionMultiSwitch.vue?vue&type=style&index=0&id=a9940a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9940a8c",
  null
  
)

export default component.exports